export default __webpack_public_path__ + "static/media/FuturaPT-Book.6b3e088d.woff2";